import { adminComplaintRoute, consumerComplaintRoute } from "Routes/constants";
import { getOptionLabel, getOptionValue } from "common/enums";

const APPLICATION = "Application";
const BILLING_CYCLE = "BillingCycle";
const CONSUMER_COMPLAINT = "ConsumerComplaint";
const TECHNICAL_SANCTION = "TechnicalSanction";
const OTHER_UTILITIES = "OtherUtilityApplication";
const DEMAND_ESTIMATE = "DemandEstimate";

export const getNavigateUrlFromNotification = (
  notificationType,
  notificationTypeId,
  isAdmin = false,
  utilityId
) => {
  switch (getOptionLabel("notificationTypes", notificationType)) {
    case APPLICATION:
      return isAdmin
        ? `/admin/applications/power-applications?applicationId=${notificationTypeId}`
        : `/my-request/power-applications?applicationId=${notificationTypeId}`;

    case BILLING_CYCLE:
      return `/admin/billing/bill-calculations?billingCycleId=${notificationTypeId}`;

    case CONSUMER_COMPLAINT:
      return isAdmin ? adminComplaintRoute : consumerComplaintRoute;

    case TECHNICAL_SANCTION:
      return utilityId === getOptionValue("utilityOptions", "Power")
        ? `/admin/applications/power-applications?technicalSanctionId=${notificationTypeId}`
        : `/admin/applications/other-applications?technicalSanctionId=${notificationTypeId}`;

    case DEMAND_ESTIMATE:
      return utilityId === getOptionValue("utilityOptions", "Power")
        ? `/admin/applications/power-applications?demandEstimationId=${notificationTypeId}`
        : `/admin/applications/other-applications?demandEstimationId=${notificationTypeId}`;

    case OTHER_UTILITIES:
      return isAdmin
        ? `/admin/applications/other-applications?applicationId=${notificationTypeId}`
        : `/my-request/other-applications?applicationId=${notificationTypeId}`;
  }
};
